import { DELETE_PRODUCER } from "./Constants"

export const deleteProducer = ( dispatch, params ) => {
	dispatch({ 
		type: DELETE_PRODUCER, 
		payload: {
			producerId:   params.producerId,
			producerData: params.producerData,
		}
	})
}
